import Vue from 'vue'
import VueRouter from 'vue-router'
import Login from '../components/auth/Login2'
import App from '../components/App'
import store from '../store' 
import ResetPassword from '../components/auth/ResetPassword.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Login',
    component: Login,
    meta: {
      requiresVisitor: true,
    }
  },
  {
    path: '/app',
    name: 'App',
    component: App,
    meta: {
      requiresAuth: true
    }
  },  
  {
    path: '/reset-password',
    name: 'ResetPassword',
    component: ResetPassword,
    meta: {
      requiresAuth: true
    }
  },  
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

router.beforeEach((to, from, next) => {
  const authenticated = store.getters['auth/getAuthenticated']
  const resetPassword = store.getters['auth/getResetPassword']

  // console.log("authenticated: ", authenticated);
  // console.log("resetPassword: ", resetPassword);

  if(authenticated && resetPassword == 1){
    if(to.path === '/reset-password') return next();

    return next('/reset-password')
  }

  if (to.matched.some(record => record.meta.requiresAuth)) {
    // this route requires auth, check if logged in
    // if not, redirect to login page.

    if (!authenticated) {
      return next('/')
    } 

    return next()

  }

  if(to.matched.some(record => record.meta.requiresVisitor)) {
    if (authenticated) {
      return next('/app')
    }

    return next()
  }

  return next()
})

export default router
